import Cookies from 'js-cookie';

const CURRENT_STUDENT_ID_COOKIE = 'currentStudentId';

export function getCurrentStudentId(): number | null {
	const rawValue = Cookies.get(CURRENT_STUDENT_ID_COOKIE);
	if (!rawValue) return null;

	const parsed = Number(rawValue);
	return Number.isFinite(parsed) ? parsed : null;
}

export function saveCurrentStudentId(currentStudentId: number) {
	Cookies.set(CURRENT_STUDENT_ID_COOKIE, `${currentStudentId}`);
}
